module.exports = __webpack_public_path__ + "img/logo-vrjmof_white.7531dace.svg";